import { postEventToServer } from "../../recorder/actions/postEventToServer";
import { validateAttributes } from "../validations";
import ajax, { isHttpError, isNetworkError } from "../../authenticationSafeAjax";
import { hashHistory } from 'react-router'
import { requestRecorderAuthenticationStatus } from "./authenticationRequests";

export const REQUEST_REGISTER_USER = "REQUEST_REGISTER_USER";
export const RECEIVE_SUCCESSFUL_REGISTER_USER = "RECEIVE_SUCCESSFUL_REGISTER_USER";
export const RECEIVE_FAILURE_REGISTER_USER = "RECEIVE_FAILURE_REGISTER_USER";
export const REGISTRATION_ATTRIBUTES_CHANGED = "REGISTRATION_ATTRIBUTES_CHANGED";
export const REGISTRATION_ATTRIBUTES_VALIDATION_FAILURE = "REGISTRATION_ATTRIBUTES_VALIDATION_FAILURE";
export const USER_DETAILS_ATTRIBUTES_VALIDATION_FAILURE = "USER_DETAILS_ATTRIBUTES_VALIDATION_FAILURE";
export const USER_DETAILS_ATTRIBUTES_CHANGED = "USER_DETAILS_ATTRIBUTES_CHANGED";
export const SAVE_USER_DETAILS_FAILED = "SAVE_USER_DETAILS_FAILED";
export const RECEIVE_UNAUTHORIZED = "RECEIVE_UNAUTHORIZED";
export const RECEIVE_AUTHORIZED = "RECEIVE_AUTHORIZED";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";

export function registrationAttributesChanged(payload) { return { type: REGISTRATION_ATTRIBUTES_CHANGED, payload }; }
export function userDetailsAttributesChanged(payload) { return { type: USER_DETAILS_ATTRIBUTES_CHANGED, payload }; }

export function requestRegisterUser() { return { type: REQUEST_REGISTER_USER}; }
export function receiveSuccessfulRegisterUser() { return { type: RECEIVE_SUCCESSFUL_REGISTER_USER }; }
export function receiveFailureRegisterUser(errors) { return { type: RECEIVE_FAILURE_REGISTER_USER, payload: errors}; }

export function registrationAttributesValidationFailure(errors) { return { type: REGISTRATION_ATTRIBUTES_VALIDATION_FAILURE, payload: errors }; }
export function userDetailsAttributesValidationFailure(errors) { return { type: USER_DETAILS_ATTRIBUTES_VALIDATION_FAILURE, payload: errors }; }

export function saveUserDetailsFailed() { return { type: SAVE_USER_DETAILS_FAILED } }

export function saveUserDetails(historyProvider = () => hashHistory) {
    return (dispatch, getState) => {
        const userDetails = getState().authentication.userDetails.attributes;


        const invalidAttributes = validateAttributes(userDetails);
        if (invalidAttributes.length !== 0) {
            dispatch(userDetailsAttributesValidationFailure(invalidAttributes));
            return;
        }

        const request = {
            body: JSON.stringify(userDetails),
            headers: { "Content-Type": "application/json", "Accept": "application/json" },
            url: "/recorder/api/user/existing",
            timeout: 10000
        };

        ajax(request, (statusCode, responseBody) => {
            if (isHttpError(statusCode) || isNetworkError(statusCode)) {
                dispatch(saveUserDetailsFailed());
            } else {
                historyProvider().push("/");
            }
        });
    }
}

export function receiveUnauthorized() { return { type: RECEIVE_UNAUTHORIZED}; }
export function receiveAuthorized(payload) { return { type: RECEIVE_AUTHORIZED, payload }; }

export function requestCheckAuthorized() {
    return (dispatch, getState) => {
        requestRecorderAuthenticationStatus(userInfo => {
            if (userInfo.userId === null) {
                dispatch(receiveUnauthorized());
            } else {
                dispatch(receiveAuthorized(userInfo));
            }
        });
    };
}

export function logoutSuccess() {
    return { type: LOGOUT_SUCCESS };
}

export function requestLogout(historyProvider = () => hashHistory) {
    return (dispatch, getState) => {
        ajax({ method: "POST", url: "/recorder/api/auth/logout" }, (code, response) => {
            dispatch(logoutSuccess());
            historyProvider().push("/sign-in");
            dispatch(requestCheckAuthorized());
        });
    };
}

export function registerUser() {
    return (dispatch, getState) => {
        const attributes = getState().authentication.registration.attributes;

        const invalidAttributes = validateAttributes(attributes);
        if (invalidAttributes.length !== 0) {
            dispatch(registrationAttributesValidationFailure(invalidAttributes));
            return;
        }

        dispatch(requestRegisterUser());

        const request = {
            body: JSON.stringify(attributes),
            headers: { "Content-Type": "application/json" },
            url: "/recorder/api/user/register",
            timeout: 10000
        };

        ajax(request, (statusCode, response) => {
            if (statusCode == 422) {
                dispatch(receiveFailureRegisterUser(JSON.parse(response).errors));
            } else if (isHttpError(statusCode)) {
                dispatch(receiveFailureRegisterUser(["Unable to register due to an unexpected error."]));
            } else if (isNetworkError(statusCode)) {
                dispatch(receiveFailureRegisterUser(["Unable to register due to connectivity issues. Please try again."]));
            } else {
                dispatch(receiveSuccessfulRegisterUser());
            }
        });
    };
}



/** WEBPACK FOOTER **
 ** ./src/main/javascript/authentication/actions/authenticationActions.js
 **/